export default __webpack_public_path__ + "static/media/000_intro_part2.hevc.69bf5566.mp4";